import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter, Route } from 'react-router-dom'
import { CacheProvider } from '@emotion/core'
import createCache from '@emotion/cache'

import './localization'
import { Provider } from 'react-redux'
import Root from 'components/Root'
import ErrorBoundary from 'portal-modules/common/components/ErrorBoundary'
import { CatastrophicError } from 'portal-modules/common/components/errors'
import LocalSyncer from 'portal-modules/common/components/LocalSyncer'
import configureStore from 'redux/configureStore'
import ThemeWrapper from './components/ThemeWrapper'
import getBrandingSettings from 'portal-modules/auth/utils/get-branding-settings'
import service from './privacy-service'
import { TPThemeProvider } from 'portal-modules/common/context/theme-context'
import { initialize as initAmplitude } from 'portal-modules/digital-analytics/digitalAnalytics'

const { clientProperties, websiteId, ...settings } = window.rpSettings

// Initialize Amplitude once at bootstrap. Idempotent, and a no-op unless running
// on the enabled Entrata dev/staging host (see digital-analytics/helpers/environment.js).
initAmplitude()

const brandingSettings = getBrandingSettings(settings)
const store = configureStore({ clientProperties, websiteId })
const cache = createCache()
// enable compatibility mode
cache.compat = true
const objService = service()
Object.keys(objService).length && objService.syncPrivacyItems()

render(
  <Provider store={store}>
    <CacheProvider value={cache}>
      <TPThemeProvider>
        <ThemeWrapper brandingSettings={brandingSettings}>
          <BrowserRouter>
            <Route
              render={routeProps => (
                <ErrorBoundary renderError={() => <CatastrophicError />}>
                  <LocalSyncer />
                  <Root {...routeProps} />
                </ErrorBoundary>
              )}
            />
          </BrowserRouter>
        </ThemeWrapper>
      </TPThemeProvider>
    </CacheProvider>
  </Provider>,
  document.getElementById('root'),
)
